"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageMismatchComponentParameters = void 0;
exports.LanguageMismatchComponentParameters = [
    {
        id: 'audio_file',
        label: 'Audio File',
        description: 'Recording to send to ECAPA LID (typically MT_INPUT files.audio)',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'language',
        label: 'Expected Language',
        description: 'Task language as a CONSTANT (e.g. TA, MAI) or another string source',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'accepted',
        label: 'Accepted',
        description: 'True when detected language matches expected, or on fail-open',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
    {
        id: 'language_mismatch',
        label: 'Language Mismatch',
        description: 'True when LID top language does not match the expected language',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
    {
        id: 'detected_language',
        label: 'Detected Language',
        description: 'Top language label returned by LID (or unknown on failure)',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'lid_confidence',
        label: 'LID Confidence',
        description: 'Confidence score for the top LID language',
        type: 'output',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'lid_scores',
        label: 'LID Scores',
        description: 'Per-language score map returned by LID',
        type: 'output',
        paramType: 'ANY',
        required: true,
    },
    {
        id: 'text_feedback',
        label: 'Text Feedback',
        description: 'Optional mismatch message written only when the clip is rejected',
        type: 'output',
        paramType: 'STRING',
        required: false,
    },
];
//# sourceMappingURL=LanguageMismatch.js.map